import { Icon } from '@iconify/react';
import { Table } from '@tanstack/react-table';

// eslint-disable-next-line react-refresh/only-export-components -- helpers de tabla compartidos
export function getSortIcon(sortDirection: false | 'asc' | 'desc'): string {
  if (sortDirection === 'asc') return 'mdi:chevron-up';
  if (sortDirection === 'desc') return 'mdi:chevron-down';
  return 'mdi:unfold-more-vertical';
}

interface PaginationControlsProps {
  pageIndex: number;
  pageCount: number;
  pageSize: number;
  pageSizeOptions: number[];
  canPreviousPage: boolean;
  canNextPage: boolean;
  onPageSizeChange: (size: number) => void;
  onPreviousPage: () => void;
  onNextPage: () => void;
}

export function PaginationControls({
  pageIndex,
  pageCount,
  pageSize,
  pageSizeOptions,
  canPreviousPage,
  canNextPage,
  onPageSizeChange,
  onPreviousPage,
  onNextPage,
}: PaginationControlsProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-sm text-foreground">
      <div className="flex items-center gap-2">
        <span>Filas por página</span>
        <select
          className="w-24 rounded-md border border-input bg-background px-3 py-2 text-sm focus:border-primary focus:outline-none text-foreground"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size} className="bg-background text-foreground">
              {size}
            </option>
          ))}
        </select>
      </div>
      <div className="flex items-center gap-3">
        <button
          className="inline-flex items-center justify-center rounded-md px-3 py-1 text-sm font-medium bg-secondary text-secondary-foreground hover:bg-secondary/80 disabled:opacity-50 transition-colors"
          onClick={onPreviousPage}
          disabled={!canPreviousPage}
        >
          Anterior
        </button>
        <span>
          Página {pageIndex + 1} de {pageCount || 1}
        </span>
        <button
          className="inline-flex items-center justify-center rounded-md px-3 py-1 text-sm font-medium bg-secondary text-secondary-foreground hover:bg-secondary/80 disabled:opacity-50 transition-colors"
          onClick={onNextPage}
          disabled={!canNextPage}
        >
          Siguiente
        </button>
      </div>
    </div>
  );
}

// eslint-disable-next-line react-refresh/only-export-components -- helpers de tabla compartidos
export function paginationPropsFromTable<T>(
  table: Table<T>,
  pageSize: number,
  pageSizeOptions: number[],
  onPageSizeChange: (size: number) => void,
): PaginationControlsProps {
  return {
    pageIndex: table.getState().pagination.pageIndex,
    pageCount: table.getPageCount(),
    pageSize,
    pageSizeOptions,
    canPreviousPage: table.getCanPreviousPage(),
    canNextPage: table.getCanNextPage(),
    onPageSizeChange,
    onPreviousPage: () => table.previousPage(),
    onNextPage: () => table.nextPage(),
  };
}

export function SortableHeaderIcon({ sortDirection }: { sortDirection: false | 'asc' | 'desc' }) {
  return (
    <Icon
      icon={getSortIcon(sortDirection)}
      className="w-4 h-4 text-slate-500"
    />
  );
}
